import { createCoordinatorQueries } from "@arcadeai/ui-kit/org-project-context/coordinator";
import { BFF_URL } from "../const";
import { sendRequest } from "../http-client";

export const coordinatorQueries = createCoordinatorQueries({
  baseUrl: BFF_URL,
  fetch: sendRequest,
});

export const {
  orgProjectKeys,
  getOrganizationsQueryOptions,
  getProjectsQueryOptions,
} = coordinatorQueries;
